export default {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  // stroke: 'currentColor',
  // strokeWidth: 2,
  // strokeLinecap: 'round',
  // strokeLinejoin: 'round',
};
